import styles from './Spinner.module.css';

interface Props {
  size?: number;
  label?: string;
}

export function Spinner({ size = 18, label }: Props) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label ?? 'Loading'}
    />
  );
}

export function PageLoader() {
  return (
    <div className={styles.page}>
      <Spinner size={32} label="Loading page" />
    </div>
  );
}
